(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-drawer')) return;

    const SECTION = 'cart-drawer';
    const OPEN_FLAG = 'rc-cart-open';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const root = () => window.Shopify?.routes?.root || '/';

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dialog) return;
        this.dialog = this.querySelector('dialog');
        this.error = this.querySelector('[data-cart-error]');
        this.status = this.querySelector('[data-cart-status]');
        this.busy = false;

        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('change', (event) => this.onChange(event));

        // Esc: animated close
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        // A click on the backdrop lands on the dialog itself
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        // Header cart link: a plain link to /cart without JavaScript
        document.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-cart-toggle]');
          if (!toggle || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open();
          this.refresh();
        });

        // Back from /cart
        try {
          if (sessionStorage.getItem(OPEN_FLAG)) {
            sessionStorage.removeItem(OPEN_FLAG);
            this.open();
          }
        } catch {}
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
      }

      close() {
        if (!this.dialog.open || this.dialog.hasAttribute('data-closing')) return;
        if (reduceMotion.matches) {
          this.dialog.close();
          return;
        }
        let closed = false;
        const done = () => {
          if (closed) return;
          closed = true;
          this.dialog.removeAttribute('data-closing');
          this.dialog.close();
        };
        this.dialog.setAttribute('data-closing', '');
        this.dialog.addEventListener('animationend', done, { once: true });
        window.setTimeout(done, 600);
      }

      onClick(event) {
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        const line = event.target.closest('[data-cart-line]');
        if (!line) return;
        const step = event.target.closest('[data-cart-step]');
        if (step) {
          const quantity = this.clamp(line, Number(line.dataset.quantity) + Number(step.dataset.cartStep));
          if (quantity !== Number(line.dataset.quantity)) this.change(line.dataset.key, quantity);
        } else if (event.target.closest('[data-cart-remove]')) {
          this.change(line.dataset.key, 0);
        }
      }

      onChange(event) {
        const input = event.target.closest('[data-cart-quantity]');
        const line = input?.closest('[data-cart-line]');
        if (!line) return;
        const quantity = this.clamp(line, Number.parseInt(input.value, 10) || 0);
        input.value = quantity;
        if (quantity === Number(line.dataset.quantity)) return;
        this.change(line.dataset.key, quantity);
      }

      // Between 0 and the line's maximum (data-max: Produto – Máximo de horas)
      clamp(line, quantity) {
        const max = Number(line.dataset.max) || Infinity;
        return Math.min(Math.max(quantity, 0), max);
      }

      // Product form: adds the chosen variant and its quantity
      add(formData) {
        const id = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;
        return this.request('cart/add.js', { items: [{ id, quantity }] });
      }

      change(key, quantity) {
        return this.request('cart/change.js', { id: key, quantity });
      }

      async request(path, body) {
        if (this.busy) return null;
        this.setBusy(true);
        const focusKey = document.activeElement?.dataset?.focusKey;
        try {
          const response = await fetch(`${root()}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...body, sections: SECTION, sections_url: window.location.pathname }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || '');
          this.showError('');
          this.render(data.sections?.[SECTION], focusKey);
          return data;
        } catch (error) {
          this.showError(error.message || this.error.dataset.fallback);
          throw error;
        } finally {
          this.setBusy(false);
        }
      }

      async refresh() {
        try {
          const response = await fetch(`${root()}?sections=${SECTION}`);
          const data = await response.json();
          this.render(data[SECTION]);
        } catch {}
      }

      render(html, focusKey) {
        if (!html) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
        const current = this.querySelector('[data-cart-content]');
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        this.syncHeader(Number(fresh.dataset.count) || 0, fresh.dataset.label);
        this.status.textContent = fresh.dataset.label || '';

        // Focus back on the same control, or on the close button when the line is gone
        if (this.dialog.open && focusKey) {
          const target = fresh.querySelector(`[data-focus-key="${CSS.escape(focusKey)}"]`);
          (target || this.querySelector('[data-cart-close]'))?.focus();
        }
      }

      syncHeader(count, label) {
        document.querySelectorAll('[data-cart-toggle]').forEach((link) => {
          let badge = link.querySelector('[data-cart-count]');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'header__cart-count';
              badge.dataset.cartCount = '';
              badge.setAttribute('aria-hidden', 'true');
              link.append(badge);
            }
            badge.textContent = count;
          } else {
            badge?.remove();
          }
          const text = link.querySelector('[data-cart-label]');
          if (text && label) text.textContent = label;
        });
      }

      setBusy(busy) {
        this.busy = busy;
        this.querySelector('[data-cart-content]')?.setAttribute('aria-busy', String(busy));
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["consulting-packs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('consulting-packs-slider')) {
    class ConsultingPacksSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.consulting-packs__track');
        this.controls = this.querySelector('.consulting-packs__controls');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.controls) return;

        this.abort = new AbortController();
        const { signal } = this.abort;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.prev.addEventListener('click', () => this.step(-1), { signal });
        this.next.addEventListener('click', () => this.step(1), { signal });
        this.track.addEventListener('scroll', () => this.schedule(), { passive: true, signal });

        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const overflowing = scrollWidth > clientWidth + 1;
        this.controls.hidden = !overflowing;
        this.prev.disabled = scrollLeft <= 1;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;

        // Cards entirely outside the content box (the padding is room for shadows)
        const box = this.track.getBoundingClientRect();
        const style = getComputedStyle(this.track);
        const start = box.left + parseFloat(style.paddingLeft);
        const end = box.right - parseFloat(style.paddingRight);
        for (const item of this.track.children) {
          const rect = item.getBoundingClientRect();
          item.toggleAttribute('data-outside', rect.right <= start + 1 || rect.left >= end - 1);
        }
      }

      step(direction) {
        const item = this.track.querySelector('.consulting-packs__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({
          left: direction * (item.offsetWidth + gap),
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('consulting-packs-slider', ConsultingPacksSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.contactFormSubject) return;
    window.contactFormSubject = true;

    // Picks a subject when it is one of the options; the enhanced select follows
    // the native one on change
    const chooseSubject = (value) => {
      const select = document.querySelector('#formulario select[name="contact[Assunto]"]');
      const subject = (value || '').trim();
      if (!select || !subject || select.value === subject) return;
      if (![...select.options].some((option) => option.value === subject)) return;
      select.value = subject;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // From another page: …/pages/contactos?assunto=…#formulario
    chooseSubject(new URLSearchParams(window.location.search).get('assunto'));

    // On this page: a #formulario link with data-contact-subject (e.g. the FAQ)
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-contact-subject]');
      if (link && link.hash === '#formulario') chooseSubject(link.dataset.contactSubject);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-actions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.contactModalReady) return;
    window.contactModalReady = true;

    const init = (dialog) => {
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';

      // A click on the backdrop lands on the dialog itself (the body fills the box)
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.querySelector('[data-contact-modal-close]')?.addEventListener('click', () => dialog.close());

      // Back from sending (success or errors): show the message in the window
      if (dialog.querySelector('.form-message')) dialog.showModal();
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-contact-modal-open]');
      if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      init(dialog);
      dialog.showModal();
      window.rcTrack?.('contact_modal_open', {});
    });

    document.querySelectorAll('[data-contact-modal]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-contact-modal]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["document-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Index: marks the topic being read (the last one whose heading has passed the
    // upper third of the screen)
    const init = (root) => {
      root.querySelectorAll('[data-document-toc]:not([data-ready])').forEach((toc) => {
        toc.dataset.ready = '';
        const links = [...toc.querySelectorAll('[data-toc-link]')];
        const targets = links.map((link) => document.getElementById(link.hash.slice(1)));
        if (targets.some((target) => !target)) return;

        const mark = () => {
          const line = window.innerHeight / 3;
          let current = 0;
          targets.forEach((target, i) => {
            if (target.getBoundingClientRect().top <= line) current = i;
          });
          links.forEach((link, i) => {
            if (i === current) {
              link.setAttribute('aria-current', 'true');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        };

        let queued = false;
        window.addEventListener(
          'scroll',
          () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(() => {
              queued = false;
              mark();
            });
          },
          { passive: true }
        );
        mark();
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-actions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Folds into the "i" once the visitor scrolls past this share of the screen height
    const FOLD_AFTER = 0.25;
    // Mobile starts folded
    const mobile = window.matchMedia('(max-width: 1023px), (orientation: portrait) and (max-width: 1366px)');

    const init = (root) => {
      for (const menu of root.querySelectorAll('[data-floating-actions]:not([data-ready])')) {
        menu.dataset.ready = '';
        const toggle = menu.querySelector('[data-floating-toggle]');
        const panel = menu.querySelector('[popover]');
        const form = menu.querySelector('.floating-actions__form');

        const setExpanded = (open) => {
          menu.toggleAttribute('data-expanded', open);
          toggle.setAttribute('aria-expanded', String(open));
        };

        // PC: open on load, folded after a little scroll. Mobile: folded from the start.
        const onScroll = () => {
          if (window.scrollY <= window.innerHeight * FOLD_AFTER) return;
          setExpanded(false);
          window.removeEventListener('scroll', onScroll);
        };
        if (mobile.matches) {
          setExpanded(false);
        } else {
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }

        // The "i": opens or folds; while the chat is open it is the chat's close
        // button (native popovertarget), so it leaves the menu alone
        toggle.addEventListener('click', () => {
          if (toggle.hasAttribute('popovertarget')) return;
          window.removeEventListener('scroll', onScroll);
          setExpanded(!menu.hasAttribute('data-expanded'));
        });

        // A tap outside or Esc folds it
        document.addEventListener('click', (event) => {
          if (menu.hasAttribute('data-expanded') && !menu.contains(event.target)) {
            window.removeEventListener('scroll', onScroll);
            setExpanded(false);
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.hasAttribute('data-expanded')) setExpanded(false);
        });

        if (panel) {
          panel.addEventListener('toggle', (event) => {
            if (event.newState === 'open') {
              toggle.setAttribute('popovertarget', panel.id);
              toggle.setAttribute('popovertargetaction', 'hide');
            } else {
              toggle.removeAttribute('popovertarget');
              toggle.removeAttribute('popovertargetaction');
              setExpanded(false);
            }
          });
        }

        form?.addEventListener('submit', (event) => {
          event.preventDefault();
          const message = form.elements.text.value.trim();
          if (!message) return;
          const text = [form.dataset.intro, message].filter(Boolean).join('\n\n');
          window.rcTrack?.('contact_click', { method: 'whatsapp', section_name: 'floating-actions' });
          window.open(`${form.action}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
          panel?.hidePopover?.();
        });
      }
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cookie-preferences]')) window.privacyBanner?.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growth-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 1600;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const easeOutExpo = (t) => (t === 1 ? 1 : 1 - 2 ** (-10 * t));
    const format = new Intl.NumberFormat(document.documentElement.lang || undefined, { useGrouping: false });

    const countUp = (el) => {
      const target = Number(el.dataset.countTo);
      if (!Number.isFinite(target)) return;
      let start;
      const frame = (now) => {
        start ??= now;
        const progress = Math.min((now - start) / DURATION, 1);
        el.textContent = format.format(Math.round(target * easeOutExpo(progress)));
        if (progress < 1) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    };

    const init = (root) => {
      if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
      const values = root.querySelectorAll('.growth-stats__value[data-count-to]:not([data-counted])');
      if (!values.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            observer.unobserve(entry.target);
            countUp(entry.target);
          }
        },
        { threshold: 0.6 }
      );

      for (const el of values) {
        el.dataset.counted = '';
        el.textContent = '0';
        observer.observe(el);
      }
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const MOBILE_QUERY = '(max-width: 1023px), (orientation: portrait) and (max-width: 1366px)';
    const mobile = window.matchMedia(MOBILE_QUERY);

    const setExpanded = (toggle, open) => {
      const target = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!target) return;
      toggle.setAttribute('aria-expanded', String(open));
      target.hidden = !open;
    };

    const closeDisclosures = (root, except) => {
      root.querySelectorAll('[data-disclosure][aria-expanded="true"]').forEach((toggle) => {
        if (toggle !== except) setExpanded(toggle, false);
      });
    };

    const setDrawer = (header, open) => {
      const toggle = header.querySelector('[data-header-toggle]');
      if (!toggle) return;
      header.toggleAttribute('data-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      // The page behind the open menu is out of reach for keyboard and screen readers
      document.querySelectorAll('#MainContent, .shopify-section-group-footer-group').forEach((el) => {
        el.inert = open;
      });
      if (!open) closeDisclosures(header);
    };

    const init = (header) => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';

      header.addEventListener('click', (event) => {
        const disclosure = event.target.closest('[data-disclosure]');
        if (disclosure) {
          const open = disclosure.getAttribute('aria-expanded') !== 'true';
          closeDisclosures(header, disclosure);
          setExpanded(disclosure, open);
          return;
        }

        if (event.target.closest('[data-header-toggle]')) {
          setDrawer(header, !header.hasAttribute('data-open'));
        }
      });

      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const openDisclosure = header.querySelector('[data-disclosure][aria-expanded="true"]');
        if (openDisclosure) {
          setExpanded(openDisclosure, false);
          openDisclosure.focus();
          return;
        }

        if (header.hasAttribute('data-open')) {
          setDrawer(header, false);
          header.querySelector('[data-header-toggle]')?.focus();
        }
      });

      header.addEventListener('focusout', (event) => {
        if (mobile.matches) return;
        header.querySelectorAll('[data-disclosure][aria-expanded="true"]').forEach((toggle) => {
          if (!toggle.parentElement.contains(event.relatedTarget)) setExpanded(toggle, false);
        });
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeDisclosures(header);
      });

      mobile.addEventListener('change', () => setDrawer(header, false));
    };

    document.querySelectorAll('[data-header]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-header]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Horizontal travel (px) that counts as a swipe on touch screens
    const SWIPE_MIN = 40;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Days left, recounted in the browser (the page may come from cache); hidden once
    // the notice has closed.
    const recount = (root) => {
      const now = Date.now() / 1000;
      root.querySelectorAll('[data-hero-deadline]').forEach((deadline) => {
        const endTs = Number(deadline.dataset.endTs);
        if (!endTs) return;
        if (endTs <= now) {
          deadline.hidden = true;
          return;
        }
        const left = Math.floor((endTs - now) / 86400);
        const days = deadline.querySelector('[data-days]');
        const unit = deadline.querySelector('[data-days-unit]');
        days.textContent = left;
        days.hidden = left === 0;
        unit.textContent =
          left === 0 ? deadline.dataset.lastDay : left === 1 ? deadline.dataset.dayOne : deadline.dataset.dayOther;
      });
    };

    const initCarousel = (carousel) => {
      if (carousel.hasAttribute('data-ready')) return;
      carousel.setAttribute('data-ready', '');

      const track = carousel.querySelector('[data-slides]');
      const slides = [...track.querySelectorAll('[data-slide]')];
      const bars = [...carousel.querySelectorAll('[data-slide-to]')];
      const count = carousel.querySelector('[data-pager-count]');
      let current = Math.max(0, slides.findIndex((slide) => slide.hasAttribute('data-active')));

      // Screen readers hear the new slide only when it was not changed automatically
      const updateLive = () => {
        const rotating = carousel.hasAttribute('data-autoplay') && !reduceMotion.matches;
        track.setAttribute('aria-live', rotating ? 'off' : 'polite');
      };

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.toggleAttribute('data-active', active);
          slide.inert = !active;
        });
        bars.forEach((bar, i) => {
          const active = i === current;
          bar.toggleAttribute('data-active', active);
          if (active) {
            bar.setAttribute('aria-current', 'true');
          } else {
            bar.removeAttribute('aria-current');
          }
        });
        if (count) count.textContent = String(current + 1).padStart(2, '0');
      };

      bars.forEach((bar, i) => {
        bar.addEventListener('click', () => show(i));
        bar.addEventListener('keydown', (event) => {
          const targets = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: bars.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          show(targets[event.key]);
          bars[current].focus();
        });
      });

      // The active bar has filled: next slide
      carousel.addEventListener('animationend', (event) => {
        if (event.target.hasAttribute('data-pager-fill')) show(current + 1);
      });

      // Swipe on touch screens (vertical scrolling stays with the browser)
      let start = null;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        start = { x: event.clientX, y: event.clientY };
      });
      track.addEventListener('pointerup', (event) => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
        show(current + (dx < 0 ? 1 : -1));
      });
      track.addEventListener('pointercancel', () => {
        start = null;
      });

      // Holds while off screen or in a background tab
      new IntersectionObserver(([entry]) => {
        carousel.toggleAttribute('data-offscreen', !entry.isIntersecting);
      }).observe(carousel);
      document.addEventListener('visibilitychange', () => {
        carousel.toggleAttribute('data-background', document.hidden);
      });

      // Theme editor: a selected block shows its slide and holds it
      carousel.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        show(index);
        carousel.setAttribute('data-held', '');
      });
      carousel.addEventListener('shopify:block:deselect', () => carousel.removeAttribute('data-held'));

      reduceMotion.addEventListener('change', updateLive);
      updateLive();
    };

    const init = (root) => {
      recount(root);
      root.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["investment-support"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.investmentSupportImages) return;
    window.investmentSupportImages = true;

    // First pointer over the list or keyboard focus inside it: every hover image of
    // that list gets its real srcset and src (srcset first, so src is not fetched twice)
    const load = (list) => {
      if (list.hasAttribute('data-images-loaded')) return;
      list.setAttribute('data-images-loaded', '');
      for (const image of list.querySelectorAll('img[data-src]')) {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      }
    };

    const onIntent = (event) => {
      const list = event.target.closest?.('[data-hover-images]');
      if (list) load(list);
    };

    document.addEventListener('pointerover', onIntent, { passive: true });
    document.addEventListener('focusin', onIntent);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notice-sheet"]) return;
  try {
    
  (() => {
    const sheet = document.querySelector('[data-notice-sheet-page]');
    if (!sheet) return;

    const print = async () => {
      await document.fonts.ready;
      window.print();
    };

    sheet.querySelector('[data-notice-sheet-print]')?.addEventListener('click', print);

    // Opened in a new tab by "Descarregar ficha": print on load, once
    if (window.self === window.top && window.location.hash === '#imprimir') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      if (document.readyState === 'complete') print();
      else window.addEventListener('load', print, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product]').forEach((root) => {
      // Gallery: a thumbnail shows its image
      const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
      const slides = [...root.querySelectorAll('[data-product-slide]')];
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.productThumb;
          slides.forEach((slide) => {
            slide.hidden = slide.dataset.productSlide !== index;
          });
          thumbs.forEach((other) => other.setAttribute('aria-pressed', String(other === thumb)));
        });
      });

      // Comprar: adds to the cart and opens the drawer (without JavaScript the form
      // goes straight to checkout through return_to)
      const form = root.querySelector('.product__form');
      const drawer = document.querySelector('cart-drawer');
      if (form && drawer?.add) {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('[data-product-buy]');
          if (button.getAttribute('aria-busy') === 'true') return;
          button.setAttribute('aria-busy', 'true');
          try {
            await drawer.add(new FormData(form));
          } catch {
            // The drawer shows the error
          } finally {
            button.removeAttribute('aria-busy');
            drawer.open();
          }
        });
      }

      // Hours as quantity (voucher): the price follows the number of hours
      const totals = root.querySelector('[data-product-totals]');
      const hoursSelect = root.querySelector('select[name="quantity"]');
      if (totals && hoursSelect) {
        const byHours = JSON.parse(totals.textContent);
        const total = root.querySelector('[data-product-price]');
        hoursSelect.addEventListener('change', () => {
          if (byHours[hoursSelect.value]) total.textContent = byHours[hoursSelect.value];
        });
      }

      // Variants with hours: price, price per hour, button and address follow the variant
      const data = root.querySelector('[data-product-variants]');
      const select = root.querySelector('select[name="id"]');
      if (!data || !select) return;

      const variants = JSON.parse(data.textContent);
      const price = root.querySelector('[data-product-price]');
      const rate = root.querySelector('[data-product-rate]');
      const buy = root.querySelector('[data-product-buy]');
      const buyLabel = root.querySelector('[data-product-buy-label]');

      select.addEventListener('change', () => {
        const variant = variants[select.value];
        if (!variant) return;
        price.textContent = variant.price;
        rate.textContent = variant.rate;
        rate.hidden = !variant.rate;
        buy.disabled = !variant.available;
        buyLabel.textContent = variant.available ? buy.dataset.labelBuy : buy.dataset.labelUnavailable;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState(window.history.state, '', url);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
